import React from "react";
import Form from "./components/Form";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import "@fontsource-variable/raleway";
import "./App.css";
import SuccessScreen from "./components/SuccessScreen";
export default function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Form />}></Route>
          <Route path="/success-screen" element={<SuccessScreen />}></Route>
        </Routes>
      </Router>
    </>
  );
}
